import { PaginationReadoutItem } from './PaginationReadoutItem';

// TODO: in v9, move styled() from PaginationReadoutItem.jsx to here
export var StyledPaginationReadoutItem = PaginationReadoutItem;